<!--发票管理-->
<template>
  <Page class="queryView">
    <template v-slot:contentTop>
      <div class="queryView-conditions with-btn-end">
        <a-form class="form" layout="inline" :form="form">
          <a-form-item label="旅行社">
            <a-select
              class="form-control"
              :options="companyList"
              allowClear
              v-decorator="['companyId']"
              placeholder="请选择"
            ></a-select>
          </a-form-item>
          <a-form-item label="状态">
            <a-select
              class="form-control"
              :options="typesMap.billState"
              allowClear
              v-decorator="['status']"
              placeholder="请选择"
            ></a-select>
          </a-form-item>
          <a-form-item label="时间">
            <a-range-picker v-model="time" />
          </a-form-item>
        </a-form>

        <div class="condition-btns">
          <a-button class="app-btn" type="default" @click="resetAndQuery">重置搜索</a-button>
          <a-button class="app-btn" type="primary" @click="doQuery(1)">立即搜索</a-button>
        </div>
      </div>
    </template>
    <template v-slot:contentCenter>
      <div>
        <div class="pageContent-title">数据信息</div>
        <div class="pt-5 data-grid">
          <div class="grid-item">
            <span class="grid-item-title">总金额：</span>
            <span class="grid-content-money text-info-500">{{ count }}元</span>
            <span>
              共
              <span class="mx-1 text-primary-500">{{ countTotal }}</span>
              笔
            </span>
          </div>
        </div>
      </div>
    </template>
    <div>
      <div class="pageContent-title">发票列表</div>
      <div class="queryView-actions">
        <a-button class="app-btn" @click="doExport">
          <app-icon type="icon-daochu"></app-icon>
          导出EXCEL
        </a-button>
      </div>
      <div class="queryView-main">
        <a-table
          class="mt-5"
          :rowKey="
            (record, index) => {
              return index
            }
          "
          bordered
          :loading="tableLoading"
          :columns="tableColumns"
          :dataSource="dataSource"
          @change="handleTableChange$qv"
          :scroll="{ x: 1400 }"
          :pagination="{
            current: pageNumber,
            pageSize: pageSize,
            total: countTotal,
            showSizeChanger: true,
            showQuickJumper: true,
          }"
        ></a-table>
      </div>
    </div>
    <DrawBill ref="DrawBill"></DrawBill>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'
import { getCompanyList } from '@/service/getData'
import fileDownload from 'js-file-download'
import DrawBill from './modules/DrawBill'
export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '5%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span> {this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '发票抬头',
        width: '15%',
        align: 'center',
        dataIndex: 'billTitle',
      },
      {
        title: '申请开票金额',
        width: '8%',
        align: 'center',
        dataIndex: 'billAmount',
        // sortOrder: 'descend',
      },
      {
        title: '状态',
        width: '10%',
        align: 'center',
        dataIndex: 'billState',
        customRender: text => {
          return <div>{this.translateType$t(text, 'billState')}</div>
        },
      },
      {
        title: '申请时间',
        width: '12%',
        align: 'center',
        dataIndex: 'createTime',
      },
      {
        title: '开票时间',
        width: '12%',
        align: 'center',
        dataIndex: 'billTime',
      },
      {
        title: '旅行社',
        width: '18%',
        align: 'center',
        customRender: (text, row) => {
          return <span>{row.companyName}</span>
        },
      },
      {
        title: '操作人',
        width: '8%',
        align: 'center',
        dataIndex: 'updateUserName',
      },
      {
        title: '操作',
        width: '13%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                onClick={() => {
                  this.checkRow(row)
                }}
              >
                查看
              </a>
              {row.billState === 0 && (
                <a
                  class="text-primary-500"
                  onClick={() => {
                    this.drawBillRow(row)
                  }}
                >
                  开票
                </a>
              )}
              <a
                onClick={() => {
                  this.handleApply(row)
                }}
              >
                申请单
              </a>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      tableLoading: false,
      tableColumns: tableColumns,
      dataSource: [],
      companyList: [],
      time: [],
      count: 0,
    }
  },
  components: {
    Page,
    DrawBill,
  },
  computed: {
    typesMap() {
      return {
        billState: [
          { value: 0, label: '未开票' },
          { value: 1, label: '已开票' },
        ],
      }
    },
  },
  async mounted() {
    this.doQuery()
    this.companyList = await getCompanyList()
  },
  methods: {
    resetAndQuery() {
      this.time = []
      this.resetAndQuery$qv()
    },
    getParams() {
      const params = this.form.getFieldsValue()
      return {
        ...params,
        startTime: this.time[0] ? this.time[0].format('YYYY-MM-DD HH:mm:ss') : '',
        endTime: this.time[1] ? this.time[1].format('YYYY-MM-DD HH:mm:ss') : '',
      }
    },
    async doQuery(_pageNumber = this.pageNumber, _pageSize = this.pageSize) {
      this.tableLoading = true
      try {
        const res = await this.$axios.post('/order-web-api/admin/order/bill/getBillPage', {
          pageNumber: _pageNumber,
          pageSize: _pageSize,
          data: {
            ...this.getParams(),
          },
        })
        if (res.data && res.data.content && res.data.content.length > 0) {
          this.count = res.data.content[0].totalAmount
        }
        this.countTotal = Number(res.data.total)
        this.dataSource = res.data.content
      } catch (e) {
        console.log(e)
      }
      this.tableLoading = false
    },
    async drawBillRow(row) {
      let id = row.billId
      const res = await this.$axios.get(`/order-web-api/admin/order/bill/${id}`)
      let params = {
        titleType: row.titleType,
        ...res.data,
      }
      await this.$refs.DrawBill.start(params)
      this.$message.success('操作成功')
      this.doQuery()
    },
    checkRow(row) {
      this.$router.push({
        path: '/m/scopeMain/billManage/billDetail',
        query: {
          billId: row.billId,
          titleType: row.titleType,
        },
      })
    },
    async doExport() {
      const res = await this.$axios.post(
        `/order-web-api/admin/order/bill/download`,
        {
          data: this.getParams(),
        },
        {
          responseType: 'blob',
          interceptors: {
            response: false,
          },
        }
      )
      fileDownload(res.data, '发票开票列表.xls')
    },
    async handleApply(row) {
      const res = await this.$axios.get(`/order-web-api/admin/order/bill/downloadApplicationForm`, {
        params: {
          id: row.billId,
        },
      })
      if (res.success) {
        window.open(res.data)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.data-grid {
  display: grid;
  grid-template-columns: minmax(25%, auto) minmax(25%, auto) minmax(25%, auto) minmax(200px, 1fr);
  color: #666;
  .grid-item {
    display: flex;
    .grid-item-title {
      min-width: 6em;
      font-weight: bold;
      color: #333;
    }
    .grid-content-money {
      min-width: 60px;
    }
  }
}
</style>
